<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-sequence5-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-sequence5-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.50459732340525;"
    data-aspect-ratio="0.505"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-sequence5-xs-img"
      class="g-sequence5-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence5-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.3761%;margin-top:-8.5px;left:76.3907%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:18</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-boxtext g-aiAbs"
      style="top:21.8659%;left:50.2521%;margin-left:-30.6061%;width:61.2121%;"
    >
      <p class="g-pstyle1">
        After agent fires, Good&rsquo;s car continues forward.
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.3218%;margin-top:-8.5px;left:76.912%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">00:20</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:41.1447%;margin-top:-9.1px;left:48.1284%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle2">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:60.4112%;margin-top:-9.1px;left:49.533%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle3">Car accelerates.</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.1145%;margin-top:-8.5px;left:76.3839%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:21</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:78.9131%;margin-top:-9.1px;right:16.2194%;width:87px;"
    >
      <p class="g-pstyle4">Parked car</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:94.3568%;margin-top:-9.1px;left:49.6773%;margin-left:-48px;width:96px;"
    >
      <p class="g-pstyle3">Car crashes.</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-sequence5-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.77951457340329;"
    data-aspect-ratio="0.78"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-sequence5-sm-img"
      class="g-sequence5-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence5-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.3752%;margin-top:-8.5px;left:67.0764%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:18</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-boxtext g-aiAbs"
      style="top:21.857%;left:50.1631%;margin-left:-19.8039%;width:39.6078%;"
    >
      <p class="g-pstyle1">
        After agent fires, Good&rsquo;s car continues forward.
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.307%;margin-top:-8.5px;left:67.4136%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle0">00:20</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:41.128%;margin-top:-9.1px;left:48.7891%;margin-left:-42.5px;width:85px;"
    >
      <p class="g-pstyle2">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:60.3866%;margin-top:-9.1px;left:49.6978%;margin-left:-59.5px;width:119px;"
    >
      <p class="g-pstyle3">Car accelerates.</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.0859%;margin-top:-8.5px;left:67.0718%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">00:21</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:78.8809%;margin-top:-9.1px;right:28.1419%;width:87px;"
    >
      <p class="g-pstyle4">Parked car</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:94.3184%;margin-top:-9.1px;left:49.7913%;margin-left:-48px;width:96px;"
    >
      <p class="g-pstyle3">Car crashes.</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-sequence5-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.00922494258426;"
    data-aspect-ratio="1.009"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-sequence5-md-img"
      class="g-sequence5-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence5-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:2.236%;margin-top:-9.6px;left:63.2105%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:18</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-boxtext g-aiAbs"
      style="top:24.9248%;left:50.126%;margin-left:-15.303%;width:30.6061%;"
    >
      <p class="g-pstyle1">
        After agent fires, Good&rsquo;s car continues forward.
      </p>
    </div>
    <div
      id="g-ai2-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:36.1826%;margin-top:-9.6px;left:63.4378%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">00:20</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:41.0057%;margin-top:-9.2px;left:49.0597%;margin-left:-47px;width:94px;"
    >
      <p class="g-pstyle2">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:60.2728%;margin-top:-10.2px;left:49.7058%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle3">Car accelerates.</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:70.1293%;margin-top:-9.6px;left:63.2105%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:21</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:78.9281%;margin-top:-9.2px;right:33.1504%;width:96px;"
    >
      <p class="g-pstyle4">Parked car</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:94.2194%;margin-top:-10.2px;left:49.7967%;margin-left:-53px;width:106px;"
    >
      <p class="g-pstyle3">Car crashes.</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-sequence5-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 4.39508170861031;"
    data-aspect-ratio="4.395"
    data-min-width="930"
  >
    <div
      id="g-sequence5-lg-img"
      class="g-sequence5-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/sequence5-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9105%;margin-top:-9.6px;left:30.3902%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:18</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9105%;margin-top:-9.6px;left:59.7395%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">00:20</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-timestamp g-aiAbs g-aiPointText"
      style="top:6.9105%;margin-top:-9.6px;left:88.2778%;margin-left:-29px;width:58px;"
    >
      <p class="g-pstyle0">00:21</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:21.8166%;margin-top:-9.2px;left:49.3328%;margin-left:-47px;width:94px;"
    >
      <p class="g-pstyle1">Good&rsquo;s car</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-yellowtext g-aiAbs g-aiPointText"
      style="top:34.104%;margin-top:-9.2px;right:9.0574%;width:96px;"
    >
      <p class="g-pstyle2">Parked car</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-boxtext g-aiAbs"
      style="top:77.0321%;left:21.1045%;margin-left:-10.8602%;width:21.7204%;"
    >
      <p class="g-pstyle3">
        After agent fires, Good&rsquo;s car continues forward.
      </p>
    </div>
    <div
      id="g-ai3-7"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:81.8355%;margin-top:-10.2px;left:49.7912%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle4">Car accelerates.</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-boxtext g-aiAbs g-aiPointText"
      style="top:81.8355%;margin-top:-10.2px;left:78.8406%;margin-left:-53px;width:106px;"
    >
      <p class="g-pstyle4">Car crashes.</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-08 15:48 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-08 15:48 -->
<!-- ai file: sequence5.ai -->
<style lang="scss">
  #g-sequence5-box {
    container-type: inline-size;
    container-name: g-sequence5-box;
  }
  #g-sequence5-box,
  #g-sequence5-box .g-artboard {
    margin: 0 auto;
  }
  #g-sequence5-box p {
    margin: 0;
  }
  #g-sequence5-box .g-aiAbs {
    position: absolute;
  }
  #g-sequence5-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-sequence5-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-sequence5-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence5-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-sequence5-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-sequence5-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-sequence5-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-sequence5-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-sequence5-lg {
        display: block !important;
      }
    }
  }
  #g-sequence5-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence5-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-sequence5-xs .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence5-xs .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }
  #g-sequence5-xs .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-xs .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence5-xs .g-pstyle4 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence5-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-sequence5-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 16px;
    height: 16px;
    font-size: 13px;
    text-align: center;
  }
  #g-sequence5-sm .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }
  #g-sequence5-sm .g-pstyle2 {
    font-weight: 700;
    height: 17px;
    text-align: center;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-sm .g-pstyle3 {
    font-weight: 700;
    height: 17px;
    text-align: center;
  }
  #g-sequence5-sm .g-pstyle4 {
    font-weight: 700;
    height: 17px;
    text-align: right;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence5-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-sequence5-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence5-md .g-pstyle1 {
    font-weight: 700;
    text-align: center;
  }
  #g-sequence5-md .g-pstyle2 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    text-align: center;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-md .g-pstyle3 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }
  #g-sequence5-md .g-pstyle4 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    text-align: right;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-sequence5-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 19px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(255, 255, 255);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-sequence5-lg .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    font-size: 15px;
    text-align: center;
  }
  #g-sequence5-lg .g-pstyle1 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    text-align: center;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-lg .g-pstyle2 {
    font-weight: 700;
    line-height: 17px;
    height: 17px;
    text-align: right;
    color: rgb(255, 136, 255);
  }
  #g-sequence5-lg .g-pstyle3 {
    font-weight: 700;
    text-align: center;
  }
  #g-sequence5-lg .g-pstyle4 {
    font-weight: 700;
    height: 19px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-roquefort($clr) {
    text-shadow:
      0 0 2px rgba($clr, 1),
      0 0 2px rgba($clr, 0.8),
      0 0 2px rgba($clr, 0.5);
  }
  .g-boxtext {
    background-color: rgba(34, 34, 34, 0.768627451);
    border-radius: 2px;
    padding: 10px 9px;
  }
  .g-timestamp {
    background-color: rgba(34, 34, 34);
    padding: 1px 3px;
  }
  .g-yellowtext {
    @include shadow-roquefort(#000000);
  }
</style>
